import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-462daabd"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "order-list"
};
const _hoisted_2 = {
  key: 3,
  class: "header-back"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "seizes"
}, null, -1));
const _hoisted_4 = ["textContent"];
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  key: 0,
  class: "cli"
};
const _hoisted_7 = {
  key: 0,
  class: "icon"
};
const _hoisted_8 = {
  key: 1,
  class: "icon-next"
};
const _hoisted_9 = {
  key: 7,
  class: "ul"
};
const _hoisted_10 = {
  key: 1,
  class: "noorder"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "noimg"
}), /*#__PURE__*/_createElementVNode("p", null, "什么都没有哦")], -1));
const _hoisted_12 = [_hoisted_11];
const _hoisted_13 = ["innerHTML"];
const _hoisted_14 = {
  class: "evaluate-gift-wrap"
};
const _hoisted_15 = {
  class: "evaluate-gift-inner"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bg-img"
}, null, -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "gift-notice"
}, "恭喜你，获得评价礼包", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_orderRemark = _resolveComponent("orderRemark");
  const _component_orderAppeal = _resolveComponent("orderAppeal");
  const _component_orderTel = _resolveComponent("orderTel");
  const _component_orderRefund = _resolveComponent("orderRefund");
  const _component_afterSaleList = _resolveComponent("afterSaleList");
  const _component_itemli = _resolveComponent("itemli");
  const _component_dialog_btn = _resolveComponent("dialog-btn");
  const _component_orderProjectRefund = _resolveComponent("orderProjectRefund");
  const _component_topay = _resolveComponent("topay");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.remarkShow ? (_openBlock(), _createBlock(_component_orderRemark, {
    key: 0,
    onOk: _cache[0] || (_cache[0] = $event => $options.close('remarkShow')),
    onDialogBack: _cache[1] || (_cache[1] = $event => $data.remarkShow = false),
    orderId: $data.orderId,
    orderType: $data.orderType,
    orderInfo: $data.orderInfo,
    remark: $data.remark
  }, null, 8, ["orderId", "orderType", "orderInfo", "remark"])) : _createCommentVNode("", true), $data.appealShow ? (_openBlock(), _createBlock(_component_orderAppeal, {
    key: 1,
    onOk: _cache[2] || (_cache[2] = $event => $options.close('appealShow')),
    onDialogBack: _cache[3] || (_cache[3] = $event => $data.appealShow = false),
    orderId: $data.orderId,
    orderType: $data.orderType,
    orderInfo: $data.orderInfo
  }, null, 8, ["orderId", "orderType", "orderInfo"])) : _createCommentVNode("", true), $data.telShow ? (_openBlock(), _createBlock(_component_orderTel, {
    key: 2,
    onOk: _cache[4] || (_cache[4] = $event => $options.close('telShow')),
    onDialogBack: _cache[5] || (_cache[5] = $event => _ctx.orderTel = false),
    orderId: $data.orderId,
    orderType: $data.orderType,
    orderInfo: $data.orderInfo
  }, null, 8, ["orderId", "orderType", "orderInfo"])) : _createCommentVNode("", true), _createVNode(_component_orderRefund, {
    orderRefundShow: $data.orderRefundShow,
    onDialogBack: _cache[6] || (_cache[6] = $event => $data.orderRefundShow = false),
    onToOp: _cache[7] || (_cache[7] = e => $options.refundFn(e, $data.orderitem)),
    orderType: $data.orderType,
    orderInfo: $data.orderInfo
  }, null, 8, ["orderRefundShow", "orderType", "orderInfo"]), $data.oneListShow || !$data.miniProgram ? (_openBlock(), _createElementBlock("section", _hoisted_2, [_hoisted_3, _createElementVNode("div", {
    class: _normalizeClass(['render-fixed-top', 'drop-back', {
      if_no_header: $options.if_no_header
    }])
  }, [_createElementVNode("span", {
    class: "title_name",
    textContent: _toDisplayString($setup.after ? '退款/售后' : $data.oneListShow ? '定金预售' : '我的订单')
  }, null, 8, _hoisted_4), _createElementVNode("div", {
    class: "drop-back-icon",
    onClick: _cache[8] || (_cache[8] = $event => $options.dropBack())
  })], 2)])) : _createCommentVNode("", true), !$data.oneListShow && !$setup.after ? (_openBlock(), _createElementBlock("div", {
    key: 4,
    class: _normalizeClass(['nav', {
      miniProgram: $data.miniProgram || !$options.if_show,
      after: $setup.after
    }])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.titleList, (item, idx) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(['nav-li', {
        li: $data.nav == item.code
      }]),
      key: idx,
      onClick: $event => $options.navTab(item.code)
    }, [_createTextVNode(_toDisplayString(item.title) + " ", 1), $data.nav == item.code ? (_openBlock(), _createElementBlock("div", _hoisted_6)) : _createCommentVNode("", true)], 10, _hoisted_5);
  }), 128))], 2)) : _createCommentVNode("", true), $setup.topTip || $data.oneListShow ? (_openBlock(), _createElementBlock("div", {
    key: 5,
    class: "top-tip",
    onClick: _cache[9] || (_cache[9] = $event => $options.jumpOneList($setup.topTip.code))
  }, [$data.oneListShow ? (_openBlock(), _createElementBlock("div", _hoisted_7)) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString($data.oneListShow ? "可在购物车与其他商品合并付款；若有优惠，优惠将在付尾款时使用" : $setup.topTip.tip) + " ", 1), !$data.oneListShow ? (_openBlock(), _createElementBlock("div", _hoisted_8)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $data.nav == 200 ? (_openBlock(), _createBlock(_component_afterSaleList, {
    key: 6,
    ref: "afterSaleList",
    standalone: false
  }, null, 512)) : (_openBlock(), _createElementBlock("div", _hoisted_9, [$data.list && $data.list.length ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($data.list, (item, index) => {
    return _openBlock(), _createBlock(_component_itemli, {
      key: item.order_id,
      item: item,
      listIndex: index,
      nav: Number($data.nav),
      onGotoDetails: $options.gotoDetails,
      onOp: $options.op,
      onShow_dialog: $options.show_dialog
    }, null, 8, ["item", "listIndex", "nav", "onGotoDetails", "onOp", "onShow_dialog"]);
  }), 128)) : (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))])), _createElementVNode("div", {
    class: "html",
    ref: "html",
    innerHTML: $data.html
  }, null, 8, _hoisted_13), _withDirectives(_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_hoisted_16, _hoisted_17, _createElementVNode("div", {
    class: "gift-confirm",
    onClick: _cache[10] || (_cache[10] = $event => $options.op({
      type: 'order_comment_add',
      item: $data.orderitem,
      orderType: $data.orderType
    }))
  }, " 立即评论 ")])], 512), [[_vShow, $data.giftWrapShow]]), _createVNode(_component_dialog_btn, {
    dialog_show: $data.dialog_show,
    onToParent: $options.close_dialog,
    dialog_btn: $data.dialog_btn,
    order_type: $data.order_type,
    list: true,
    onToOp: _cache[11] || (_cache[11] = e => {
      $data.dialog_show = false;
      $options.op({
        type: e,
        item: $data.orderitem,
        orderType: $data.orderType
      });
    })
  }, null, 8, ["dialog_show", "onToParent", "dialog_btn", "order_type"]), _createVNode(_component_dialog_btn, {
    dialog_show: $data.dialog_address,
    onToParent: _cache[12] || (_cache[12] = $event => $data.dialog_address = false),
    dialog_btn: $data.addressBtn,
    order_type: $data.order_type,
    list: true,
    onToOp: _cache[13] || (_cache[13] = e => $options.toAddress(e, $data.orderitem, $data.orderType))
  }, null, 8, ["dialog_show", "dialog_btn", "order_type"]), $data.refundInfo ? (_openBlock(), _createBlock(_component_orderProjectRefund, {
    key: 8,
    show: $data.orderProjectRefundShow,
    info: $data.refundInfo,
    onClosePopup: _cache[14] || (_cache[14] = $event => $data.orderProjectRefundShow = false),
    onGoNext: $options.goNext
  }, null, 8, ["show", "info", "onGoNext"])) : _createCommentVNode("", true), $data.payShow ? (_openBlock(), _createBlock(_component_topay, {
    key: 9,
    class: "topay",
    orderInfo: $data.orderInfo,
    list: $data.methodsList,
    pay_resource: $data.pay_resource,
    onClose: _cache[15] || (_cache[15] = $event => $data.payShow = false),
    onPayClick: $options.payClick
  }, null, 8, ["orderInfo", "list", "pay_resource", "onPayClick"])) : _createCommentVNode("", true)]);
}